module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "amazon-root"
    },
    on: {
      "click": _vm.clicked
    }
  }, [_c('div', {
    staticClass: " col-xs-8 col-xs-offset-2 csp-no-pad"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.amazonSigninLoading) ? _c('div', {
    staticClass: "col-xs-2 csp-no-pad"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2464a6c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/idp/Amazon.vue
// module id = 854
// module chunks = 2